module.exports = __webpack_public_path__ + "static/media/contact.4d83e134.svg";